import { gql, useMutation } from "@apollo/client";
import { ItemTypeEnum } from "@enums/ItemTypeEnum";
import { cartVar } from "./useCart";

export type CheckoutInputType = {
  cartId: string,
  typeItem: ItemTypeEnum[];
}

const CART = gql`
  mutation ClearItemsByType($input: Cart_ClearItemsByTypeInput!) {
    Cart_clearItemsByType(input: $input) {
      id
      customerCode
      industryCode
      status
      code
      customCode
      userId
      grossPrice
      netPrice
      valid
      discountValue
      coupons
      shippingOrders {
        code
        paymentTerm
      }
      items {
        code
        amount
        totalDiscount
        commercialPolicyId
        type
        valid
        unitGrossPrice
        unitNetPrice
        grossPrice
        netPrice
        discountValue
        discount
        errors {
          type
          message
        }
        discountsTrace
        coupons {
          name
          percentage
        }
        product {
          code
          description
          brand {
            id
            description
          }
          assortment {
            name
          }
        }
        suggestions {
          list {
            name
            code
            amount
          }
          anchor {
            anchorAmount
          }
        }
      }
    }
  }
`;

export const useClearByType = () => {
  return useMutation(CART, {
    onCompleted(data) {
      if (data.Cart_clearItemsByType) {
        cartVar(data.Cart_clearItemsByType)
      }
    },
  });
};
